import React from 'react';
import { Link } from 'react-router-dom';

// Define the Product interface that matches what's used in PriseRdvPage.tsx
interface Option {
  name: string;
  price: {
    amount: number;
    unit: string;
  };
}

interface Times{
  "from": string;
  "to": string;
}
interface Dates{
  "dateStart": string;
  "dateEnd": string;
}

interface Product {
  id: number;
  name: string;
  description: string[];
  price: {
    amount: number;
    unit: string;
  };
  options?: Option[];
  duration: string;
  times?: Times[];
  dates?: Dates[];
  places: number;
}

interface ProductCardProps {
  product: Product;
  onClick?: () => void; // Optional click handler for booking context
}
const formatDuration = (duration: Product['duration']) => {
    if (duration.includes('h')) {
      // Gère les durées au format "2h", "2h30"
      // Extract hours and minutes separately
      const hoursMatch = duration.match(/(\d+)h/);
      const minutesMatch = duration.match(/(\d+)min/);
      
      if (hoursMatch) {
        const hours = parseInt(hoursMatch[1], 10);
        let result = `${hours} heure${hours > 1 ? 's' : ''}`;
        
        // If there are minutes, add them to the result
        if (minutesMatch) {
          const minutes = parseInt(minutesMatch[1], 10);
          if (minutes > 0) {
            result += ` ${minutes} minute${minutes > 1 ? 's' : ''}`;
          }
        }
        
        return result;
      }
    } else if (duration.includes('day')) {
      // Gère les durées au format "1day", "2days"
      const daysMatch = duration.match(/(\d+)day/);
      if (daysMatch) {
        const days = parseInt(daysMatch[1], 10);
        return `${days} jour${days > 1 ? 's' : ''}`;
      }
    }
    return '';
  };
const ProductCard: React.FC<ProductCardProps> = ({ product, onClick }) => {
  

  // If there's an onClick handler, use it for click events instead of Link
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div 
      className="product-card" 
      style={{ 
        border: '1px solid #c3e6cb', 
        borderRadius: '10px', 
        backgroundColor: '#f0fff0', 
        padding: '25px',
        cursor: onClick ? 'pointer' : 'default'
      }}
      onClick={handleClick}
    >
      <h3>{product.name}</h3>
      
      <div className="product-details">
        <p><strong>{product.description != null ? product.description.join(', ') : ''}</strong></p>
        <p><strong>Prix:</strong> {product.price.amount}€ {product.price.unit ==="booking" ? "par personne" : product.price.unit ==="day" ? "par jour" : ""}</p>
        
        <p><strong>Durée:</strong> {formatDuration(product.duration)}</p>
        <p><strong>Places:</strong> {product.places}</p>
        {product.options && product.options.length > 0 && (
          <div style={{ marginTop: '10px' }}>
            <p><strong>Options:</strong></p>
            <ul>
              {product.options.map((option, index) => (
                <li key={index}>{option.name} (+{option.price.amount}€)</li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {!onClick && ( // Only show the "Se Renseigner" button if we're not in booking context
        <div className="product-footer">
          {/* The link should go to the contact page and pass product ID */}
          <Link 
            to={`/contact?object=${encodeURIComponent(product.name)}`} 
            className="info-button" 
            style={{ display: 'inline-block', padding: '10px 20px', backgroundColor: '#4CAF50', color: 'white', textDecoration: 'none', borderRadius: '8px', cursor: 'pointer' }}
          >
            Se Renseigner
          </Link>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
export type { ProductCardProps, Product, Option, Times, Dates };
export { formatDuration };